import styled from 'styled-components';

import { Text } from '../../../../components';
import { ANIM, COLORS, SPACE } from '../../../../theme/tokens';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[2]};
  max-height: 280px;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
`;

export const Option = styled.li<{ $selected: boolean }>`
  padding: ${SPACE[8]} ${SPACE[12]};
  border-radius: 10px;
  background: ${({ $selected }) => ($selected ? COLORS.surfaceMuted : 'transparent')};
  color: ${COLORS.text};
  font-size: 13px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: background ${ANIM.INTERACT_MS}ms ease;

  &:hover,
  &:focus-visible {
    background: ${COLORS.surfaceFaint};
    outline: none;
  }
`;

export const OptionPath = styled(Text)`
  color: ${COLORS.textMuted};
`;

export const SkeletonRow = styled.li`
  padding: ${SPACE[8]} ${SPACE[12]};
`;

export const Message = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

export const ErrorRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACE[8]};
`;

export const ErrorText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.danger};
`;
